import { request } from '@/common/utils/request'

export function fetchAreaList (params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getMapList',
    params
  }).then(res => res.data)
}

export function fetchShopList (params) {
  return request.get({
    url: 'crm.bdapp.bizopp.getListForMapInApp',
    params
  }).then(res => res.data)
}
